// removed by extract-text-webpack-plugin
module.exports = {"block":"AppTitle__block-3yI2T","small":"AppTitle__small-21riT","medium":"AppTitle__medium-1cjhz","large":"AppTitle__large-LY1xl"};